import React, { useState } from 'react';
import { getLabel } from '../../data/labels';

function Keypad(props) {
    const [amount, setAmount] = useState('');
    const decimalSeparator = props.decimalSeparator;
    const firstLine = [7, 8, 9];
    const secondLine = [4, 5, 6];
    const thirdLine = [1, 2, 3];

    function addInteger(n) {
        if (amount?.length === 0 ?? false) {
            return;
        }
        const parts = String(amount).split(decimalSeparator);
        let integerPart = parts[0];
        integerPart = parseInt(integerPart, 10) + n;
        if (integerPart < 0) {
            return;
        }
        integerPart += '';
        let newAmount = null;
        if (parts.length > 1) {
            newAmount = integerPart + decimalSeparator + parts[1];
        } else {
            newAmount = integerPart;
        }
        setAmount(newAmount);
    }
    
    function addChar(c) {
        c = c + '';
        let newAmount = null;
        if (!amount.includes(decimalSeparator) && parseInt(amount, 10) === 0) {
            newAmount = c;
        } else {
            newAmount = amount + c;
        }
        setAmount(newAmount);
    }
    
    function removeChar() {
        if (amount.length > 0) {
            setAmount(amount.slice(0, amount.length - 1));
        }
    }

    function addDecimalSeparator() {
        if (amount.includes(decimalSeparator)) {
            return;
        } else {
            setAmount(amount + decimalSeparator);
        }
    }
    
    function handleReset() {
        setAmount('0');
    }

    function handleOK() {
        if (amount?.length > 0 ?? false) {
            props.setAmount(amount);
        }
        props.close();
    }

    return (
        <div className="custom-calc-payment-pad custom-calc-pad-placeholder">
            <div id="custom-calc-pad-keys">
                <div className="custom-calc-digits-row custom-calc-lite-pad-display-container">
                    <div id="custom-calc-cart-keyboard" className="custom-calc-lite-pad-display">{amount} {props.currency}</div>
                    <div id="custom-calc-pad-display-hidden"></div>
                </div>
                <div className="custom-calc-digits-row">
                    <div className="custom-calc-key-child custom-calc-addsub" onClick={() => addInteger(-1)}>
                        <button><span>-1</span></button>
                    </div>
                    <div className="custom-calc-key-child custom-calc-addsub" onClick={() => addInteger(-5)}>
                        <button><span>-5</span></button>
                    </div>
                    <div className="custom-calc-key-child custom-calc-addsub" onClick={() => addInteger(+5)}>
                        <button><span>+5</span></button>
                    </div>
                    <div className="custom-calc-key-child custom-calc-addsub" onClick={() => addInteger(+1)}>
                        <button><span>+1</span></button>
                    </div>
                </div>
                <div className="custom-calc-digits-row">
                    {firstLine.map(b => {
                        return (
                            <div key={b} className="custom-calc-key-child custom-calc-number" onClick={() => addChar(b)}>
                                <button><span>{b}</span></button>
                            </div>
                        )
                    })}
                    <div id="custom-calc-pad-clear" className="custom-calc-pad-clear custom-calc-key-child" onClick={handleReset}>
                        <button className="text-medium">
                            <span>{getLabel('general.clear', 'Clear')}</span>
                        </button>
                    </div>
                </div>
                <div className="custom-calc-digits-row">
                    {secondLine.map(b => {
                        return (
                            <div key={b} className="custom-calc-key-child custom-calc-number" onClick={() => addChar(b)}>
                                <button><span>{b}</span></button>
                            </div>
                        )
                    })}
                    <div id="custom-calc-pad-back-space" className="custom-calc-pad-back-space custom-calc-key-child" onClick={removeChar}>
                        <button className="text-medium">
                            <span>CE</span>
                        </button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="custom-calc-last-digits-row-container">
                        <div className="custom-calc-digits-row">
                            {thirdLine.map(b => {
                                return (
                                    <div key={b} className="custom-calc-key-child custom-calc-number" onClick={() => addChar(b)}>
                                        <button><span>{b}</span></button>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="custom-calc-digits-row">
                            <div id="custom-calc-pad-close" className="custom-calc-pad-close custom-calc-key-child" onClick={props.close}>
                                <button className="text-medium">
                                    <span>{getLabel('general.close')}</span>
                                </button>
                            </div>
                            <div className="custom-calc-key-child custom-calc-number" onClick={() => addChar(0)}>
                                <button><span>0</span></button>
                            </div>
                            {props.decimalsEnabled &&
                                <div id="custom-calc-pad-decimal-point" className="custom-calc-pad-decimal-point custom-calc-key-child" onClick={addDecimalSeparator}>
                                    <button><span>{decimalSeparator}</span></button>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="custom-calc-digits-row custom-calc-ok-button-container" onClick={handleOK}>
                        <div id="custom-calc-pad-ok" className="custom-calc-pad-ok custom-calc-key-child">
                            <button><span className="custom-calc-ok-button">OK</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Keypad;